function Loading() {
    return (
        <div id="loading-component">
            <svg>
                <use href="#ico"/>
            </svg>
        </div>
    );
}

export default Loading;
